<template>
  <div>
    <el-tabs v-model="activeTab" @tab-click="handleClick">
      <el-tab-pane label="GL Tax Accounts" name="GLTaxAccounts">
        <GLTaxAccounts ref="GLTaxAccounts"/>
      </el-tab-pane>
      <el-tab-pane label="Vendors (Expanded)" name="vendors">
        <vendors ref="vendors"/>
      </el-tab-pane>
      <el-tab-pane label="Alphalist (Esubmission)" name="esubmission">
        <esubmission ref="esubmission"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import GLTaxAccounts from '@/components/taxation/withholdingTaxPortal/taxManagement/GLTaxAccounts.vue'
  import Vendors from '@/components/taxation/withholdingTaxPortal/taxManagement/Vendors.vue'
  import Esubmission from '@/components/taxation/withholdingTaxPortal/taxManagement/Esubmission.vue'

  export default {
    name: 'TaxManagement',
    components: {
      GLTaxAccounts,
      Vendors,
      Esubmission,
    },
    data() {
      return {
        activeTab: 'GLTaxAccounts',
        msg: 'Sorry, this feature now under development will be ready later.',
      }
    },
    methods: {
      loadList() {
        this.activeTab = 'GLTaxAccounts'
        this.$refs['GLTaxAccounts'].loadList()
      },
      handleClick(tab, event) {
        if (tab.name === 'GLTaxAccounts'){
          this.$refs['GLTaxAccounts'].loadList()
        } else if (tab.name === 'vendors') {
          this.$refs['vendors'].loadList()
        } else if (tab.name === 'esubmission'){
          this.$refs['esubmission'].loadList()
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>